<script setup lang="ts">
import DropdownItem from '../common/DropdownItem.vue';
import type { MenuItem } from 'primevue/menuitem';
import { IconLanguage } from '@iconify-prerendered/vue-ic';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const languageStore = useLanguageStore();
const { language, translations } = storeToRefs(languageStore);

const items = computed<MenuItem[]>(() => languageStore.supportedLanguages.map((l) => {
  return {
    label: l.title,
    command: () => {
      languageStore.select(l.code);
    },
  };
}));
</script>

<template>
  <DropdownItem
    :title="translations.settings.general.language"
    :description="language.title"
    :items="items"
  >
    <template #icon><IconLanguage style="width: 2rem; height: 2rem"></IconLanguage></template>
  </DropdownItem>
</template>
